import { apiSlice } from "./apiSlice";

export const adminMileageApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getMileageChargeRequestAdmin: build.query({
            query: (params) => ({
                url: "/api/admin/mileage/v1/charge/request",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),
        getMileageHistoryAdmin: build.query({
            query: (params) => ({
                url: "/api/admin/mileage/v1/history",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),
        postMileageChargeConfirm: build.mutation({
            query: (mileageChargeRequestId) => ({
                url: `/api/admin/mileage/v1/charge/${mileageChargeRequestId}/confirm`,
                method: "post",
                headers: { token: true },
            }),
        }),
        putMileageChargeConfirmCancel: build.mutation({
            query: (mileageChargeRequestId) => ({
                url: `/api/admin/mileage/v1/charge/${mileageChargeRequestId}/confirm/cancel`,
                method: "put",
                headers: { token: true },
            }),
        }),
        putMemberMileage: build.mutation({
            query: ({ memberId, body }) => ({
                url: `/api/admin/member/v1/${memberId}/mileage`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),
    }),
});

export const {
    useGetMileageChargeRequestAdminQuery,
    useGetMileageHistoryAdminQuery,
    usePostMileageChargeConfirmMutation,
    usePutMileageChargeConfirmCancelMutation,
    usePutMemberMileageMutation,
} = adminMileageApi;
